import i18n from 'i18next'

function compactNumber(amount: number): string {
  const locale = i18n.language

  return new Intl.NumberFormat(locale, { notation: 'compact' }).format(amount)
}

export { compactNumber }
